/** Format unknown cell values for display in admin tables. */

import { formatApiError } from '@/utils/formatApiError';

/** Readable error text for table cells — never returns `[object Object]`. */
export function formatTableError(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || '—';
  }
  const readable = formatApiError(value, '');
  if (readable) {
    return readable;
  }
  return formatCellValue(value);
}

export function formatCellValue(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }
  if (typeof value === 'number') {
    return String(value);
  }
  if (typeof value === 'string') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((item) => formatCellValue(item)).join(', ');
  }
  if (typeof value === 'object') {
    const readable = formatApiError(value, '');
    if (readable) {
      return readable;
    }
    try {
      return JSON.stringify(value);
    } catch {
      const text = String(value);
      return text === '[object Object]' ? '—' : text;
    }
  }
  const text = String(value);
  return text === '[object Object]' ? '—' : text;
}

export function cellTooltipText(text: string, sensitive: boolean): string | undefined {
  if (sensitive || text === '—') {
    return undefined;
  }
  return text;
}

export function cellDisplayText(text: string, sensitive: boolean): string {
  if (sensitive) {
    return '••••••';
  }
  return text;
}
